import { useQuery } from "@apollo/client";

import { GqlNotificationGetAllParams, gql } from "~/__generated__";

const NOTIFICATION_GET_ALL = gql(`
  query NotificationGetAll($params: GqlNotificationGetAllParams!) {
    notificationGetAll(params: $params) {
      data {
        id
        title
        body
        ctaUrl
        ctaTitle
        sender {
          id
          firstName
          lastName
          profilePictureMedia {
            id
            name
            mimeType
            isUploaded
            url
          }
        }
        receiverId
        createdAt
        isRead
        isSent
      }
      queryInfo {
        paginationOption {
          page
          total
        }
      }
      unreadCount
    }
  }
`);

export default function useNotificationGetAll(params: GqlNotificationGetAllParams) {
    const { data, loading, error } = useQuery(NOTIFICATION_GET_ALL, {
        variables: { params },
        pollInterval: 10000,
        fetchPolicy: "network-only",
    });

    return {
        loading,
        error,
        totalRows: data?.notificationGetAll.queryInfo.paginationOption.total ?? 0,
        data: data?.notificationGetAll?.data,
        unreadNotificationsCount: data?.notificationGetAll.unreadCount ?? 0,
    };
}
